import apiClient from './api'

export const templateService = {
  /**
   * Alle verfügbaren Quittungsvorlagen abrufen
   */
  async getAvailableTemplates() {
    const response = await apiClient.get('/templates')
    return response.data
  },

  /**
   * Team-spezifische Quittungsvorlagen abrufen
   */
  async getTeamReceiptTemplates(teamId) {
    const response = await apiClient.get(`/teams/${teamId}/receipt-templates`)
    return response.data
  },

  
  async getAllTemplates(includeInactive = false) {
    const response = await apiClient.get('/templates', {
      params: { includeInactive }
    })
    return response.data
  },

  async getPersonalTemplate() {
    const response = await apiClient.get('/templates/personal')
    return response.data
  },

  async getTeamTemplates(teamId) {
    const response = await apiClient.get(`/teams/${teamId}/templates`)
    return response.data
  },

  async updateTeamTemplateCustomName(teamTemplateId, customName) {
    try {
      const response = await apiClient.put(`/teams/templates/${teamTemplateId}/custom-name`, {
        customName
      })
      return response.data
    } catch (error) {
      
      if (error.response?.status === 404) {
        console.warn('Custom name endpoint not available, trying alternative approach')
        const response = await apiClient.post(`/teams/${teamId}/templates`, {
          templateId,
          customName
        })
        return response.data
      }
      throw error
    }
  },

  async updateTeamTemplateNeedsSignature(teamTemplateId, needsSignature) {
    const response = await apiClient.put(`/teams/templates/${teamTemplateId}/needs-signature`, {
      needsSignature
    })
    return response.data
  },

  async updateTeamTemplateTitleSettings(teamTemplateId, titleSettings) {
    const response = await apiClient.put(`/teams/templates/${teamTemplateId}/title-settings`, {
      titleSettings
    })
    return response.data
  },

  async updateTeamTemplateFieldGroups(teamTemplateId, fieldGroups) {
    const response = await apiClient.put(`/teams/templates/${teamTemplateId}/field-groups`, {
      fieldGroups
    })
    return response.data
  },

  async setTeamTemplateDefault(teamId, teamTemplateId) {
    const response = await apiClient.put(`/teams/${teamId}/templates/${teamTemplateId}/set-default`)
    return response.data
  },

  async getTemplateById(templateId) {
    const response = await apiClient.get(`/templates/${templateId}`)
    return response.data
  },

  async createTemplate(templateData) {
    const response = await apiClient.post('/templates', templateData)
    return response.data
  },

  async updateTemplate(templateId, templateData) {
    const response = await apiClient.put(`/templates/${templateId}`, templateData)
    return response.data
  },

  
  async getTemplateFields(templateId) {
    const response = await apiClient.get(`/templates/${templateId}/fields`)
    return response.data
  },

  async downloadTemplateExcel(templateId) {
    const response = await apiClient.get(`/team-template-drafts/${templateId}/excel`, {
      responseType: 'blob'
    })
    return {data: response.data, headers: response.headers}
  },

  async uploadTemplateExcel(teamTemplateId, file) {
    const formData = new FormData()
    formData.append('excelFile', file)
    
    const response = await apiClient.post(`/team-template-drafts/${teamTemplateId}/upload-excel`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
    return response.data
  },

  async createCustomField(templateId, fieldData) {
    const response = await apiClient.post(`/templates/${templateId}/fields`, fieldData)
    return response.data
  },



  async createAdminField(templateId, fieldData) {
    const response = await apiClient.post(`/templates/${templateId}/admin-fields`, fieldData)
    return response.data
  },

  async updateTemplateFieldGroups(templateId, fieldGroups) {
    const response = await apiClient.put(`/templates/${templateId}/field-groups`, {
      fieldGroups
    })
    return response.data
  },

  async updateTemplateField(fieldId, fieldData) {
    const response = await apiClient.put(`/templates/fields/${fieldId}`, fieldData)
    return response.data
  },

  async deleteTemplateField(fieldId) {
    const response = await apiClient.delete(`/templates/fields/${fieldId}`)
    return response.data
  },

  
  async getAllCategories(includeInactive = false) {
    const response = await apiClient.get('/template-categories', {
      params: { includeInactive }
    })
    return response.data
  },

  async createCategory(categoryData) {
    const response = await apiClient.post('/template-categories', categoryData)
    return response.data
  },

  async updateCategory(categoryId, categoryData) {
    const response = await apiClient.put(`/template-categories/${categoryId}`, categoryData)
    return response.data
  },

  async deleteCategory(categoryId) {
    const response = await apiClient.delete(`/template-categories/${categoryId}`)
    return response.data
  },

  async deleteTemplate(templateId) {
    const response = await apiClient.delete(`/templates/${templateId}`)
    return response.data
  },

  async setDefaultTemplate(templateId) {
    const response = await apiClient.put(`/templates/${templateId}/set-default`)
    return response.data
  },

  async assignTemplateToTeam(teamId, templateId, isDefault = false, customName = null) {
    const response = await apiClient.post(`/teams/${teamId}/templates`, {
      templateId,
      isDefault,
      customName
    })
    return response.data
  },

  async removeTeamTemplate(teamTemplateId) {
    const response = await apiClient.delete(`/teams/templates/${teamTemplateId}`)
    return response.data
  },

  
  async getDefaultTemplate() {
    const response = await apiClient.get('/templates/default')
    return response.data
  },

  async listTemplates() {
    const response = await apiClient.get('/templates/list')
    return response.data
  },

  async debugAdminStatus() {
    const response = await apiClient.get('/templates/debug/admin-status')
    return response.data
  },

  async initStandardFields(templateId) {
    const response = await apiClient.post(`/templates/${templateId}/init-standard-fields`)
    return response.data
  },

  
  async getAllTaxRates(includeInactive = false) {
    const response = await apiClient.get('/tax-rates', {
      params: { includeInactive }
    })
    return response.data
  },

  async getTaxRateById(taxRateId) {
    const response = await apiClient.get(`/tax-rates/${taxRateId}`)
    return response.data
  },

  async createTaxRate(taxRateData) {
    const response = await apiClient.post('/tax-rates', taxRateData)
    return response.data
  },

  async updateTaxRate(taxRateId, taxRateData) {
    const response = await apiClient.put(`/tax-rates/${taxRateId}`, taxRateData)
    return response.data
  },

  async deleteTaxRate(taxRateId) {
    const response = await apiClient.delete(`/tax-rates/${taxRateId}`)
    return response.data
  },

  async setDefaultTaxRate(taxRateId) {
    const response = await apiClient.put(`/tax-rates/${taxRateId}/set-default`)
    return response.data
  },

  async getDefaultTaxRate() {
    const response = await apiClient.get('/tax-rates/default')
    return response.data
  },

  async initializeDefaultTaxRates() {
    const response = await apiClient.post('/tax-rates/initialize')
    return response.data
  },



  /**
   * Get team templates with resolved TaxRates
   */
  async getTeamTemplatesWithTaxRates(teamId) {
    const response = await apiClient.get(`/teams/${teamId}/templates`)
    return response.data
  },

  /**
   * Get all templates with resolved TaxRates
   */
  async getAllTemplatesWithTaxRates(includeInactive = false) {
    const response = await apiClient.get('/templates', {
      params: { 
        includeInactive
      }
    })
    return response.data
  }
} 
